// src/pages/LifesavingInstructor.jsx
import CourseSchedule from '../components/CourseSchedule';

const sessions = [
  {
    title: "Lifesaving Instructor (Accelerated)",
    date: "May 20 – May 24, 2025",
    time: "Tues–Sat, 10am–4pm",
    location: "PSA Downtown",
    price: 280
  }
];

const LifesavingInstructor = () => (
  <div className="bg-white text-gray-900 font-sans">
    <section className="pt-32 pb-16 px-6 max-w-4xl mx-auto">
      <h1 className="text-4xl font-bold mb-6 text-blue-800">Lifesaving Instructor</h1>
      <p className="text-lg mb-4">
        Become a certified Lifesaving Instructor and teach essential lifesaving skills...
      </p>
    </section>

    <CourseSchedule sessions={sessions} />
  </div>
);

export default LifesavingInstructor;
